import { Menu } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { useHistory } from "react-router-dom";
import { ReactComponent as DASHBOARD } from "../../assets/icons/dashboard.svg";
import { ReactComponent as LOGOUT } from "../../assets/icons/logout.svg";
import { ReactComponent as ANNOUCE } from "../../assets/icons/megaphone.svg";
import { ReactComponent as TICKETS } from "../../assets/icons/tickets.svg";
import { ReactComponent as FILE_CONF } from "../../assets/icons/file-conf.svg";
import { ReactComponent as ANNOUCE_CONFIG } from "../../assets/icons/announce-settings.svg";
import { ROUTE_ANNOUNCEMENTS, ROUTE_ANNOUNCEMENTS_CONFIG, ROUTE_DASHBOARD, ROUTE_FILE_CONFIGURATION, ROUTE_TICKETS } from "../../core/route/ui.routes";
import { logout } from "../../core/store/reducers/auth.slice";
import { PERMISSIONS, RootState } from "../constants";
const { SubMenu } = Menu;

const Sidebar = (props: any) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { myPermissions, user } = useSelector((state: RootState) => state.auth);
  console.log(myPermissions)
  const MENU_ITEMS: any = [
    {
      name: "Dashboard",
      key: "dashboard",
      icon: <DASHBOARD />,
      route: ROUTE_DASHBOARD,
      children: [],
      mobileView: false,
    },
    {
      name: "Tickets",
      key: "tickets",
      icon: <TICKETS />,
      route: ROUTE_TICKETS,
      children: [],
      mobileView: true,
      permission: PERMISSIONS.READ_TICKET,
    },
    {
      name: "Announcements",
      key: "announce",
      icon: <ANNOUCE />,
      route: ROUTE_ANNOUNCEMENTS,
      children: [],
      mobileView: true,
      permission: PERMISSIONS.USER_ANNOUNCEMENT_LIST
    },
    {
      name: "Announcement Config",
      key: "announce-config",
      icon: <ANNOUCE_CONFIG />,
      route: ROUTE_ANNOUNCEMENTS_CONFIG,
      children: [],
      mobileView: true,
      permission: PERMISSIONS.ANNOUNCEMENT_CONFIG,
    },
    {
      name: "File Configuration",
      key: "file-conf",
      icon: <FILE_CONF />,
      route: ROUTE_FILE_CONFIGURATION,
      children: [],
      mobileView: true,
      permission: PERMISSIONS.FILE_CONFIGURATION,
    },
    // {
    //   name: "Logout",
    //   key: "logout",
    //   icon: <LOGOUT />,
    //   route: "logout",
    //   children: [],
    //   mobileView: true,
    // },
    {
      name: `${user?.first_name ? user?.first_name : ""}  ${
        user?.last_name ? user?.last_name : ""
      }`,
      key: "settings",
      className: "settings capitalize",
      icon: (
        <span className="user-letter-circle capitalize">
          {(user?.first_name ? user?.first_name?.split("")[0] : "") +
            (user?.last_name ? user?.last_name?.split("")[0] : "")}
        </span>
      ),
      route: "nopath",
      mobileView: true,
      children: [
        {
          name: (
            <div>
              {user?.first_name ? user?.first_name : ""}{" "}
              {user?.last_name ? user?.last_name : ""}
              <br />
              <small>{user?.phone ? user?.phone : ""}</small>
            </div>
          ),
          key: "name",
          route: "name",
          children: [],
        },

        {
          name: "Logout",
          key: "logout",
          route: "logout",
          children: [],
        },
      ],
    },
  ];
  const screenType = {
    desktop: useMediaQuery({ minWidth: 992 }),
    tablet: useMediaQuery({ minWidth: 768, maxWidth: 991 }),
    mobile: useMediaQuery({ maxWidth: 767 }),
  };
  const allPermissions = myPermissions?.scope_values?.actions;
  return (
    <>
      <Menu
        id="sidebar"
        onClick={(e: any) => {
          if (
            e.key !== "nopath" &&
            e.key !== "nopaths" &&
            e.key !== "name" &&
            e.key !== "logout"
          ) {
            history.push(e.key);
          }
          if (e.key == "logout") {
            dispatch(logout());
            // localStorage.clear();
            // history.push(ROUTE_LOGIN_APP);
            // window.location.reload();
          }
        }}
        defaultOpenKeys={[MENU_ITEMS[0].name]}
        mode="inline"
        itemIcon={true}
      >
        {MENU_ITEMS.map((menuGroup: any) => {
          if (
            (screenType.mobile && menuGroup.mobileView) ||
            !screenType.mobile
          ) {
            if (menuGroup?.children?.length === 0) {
              if (
                menuGroup?.permission &&
                allPermissions?.indexOf(menuGroup?.permission) === -1 &&
                allPermissions?.indexOf(
                  menuGroup?.permission?.split(".")[0]
                ) === -1
              ) {
                return <></>;
              } else {
                return (
                  <Menu.Item key={menuGroup.route} icon={menuGroup.icon}>
                    {menuGroup.name}
                  </Menu.Item>
                );
              }
            }else {
              if (
                menuGroup?.permission &&
                myPermissions?.indexOf(menuGroup?.permission) === -1 &&
                myPermissions?.indexOf(menuGroup?.permission?.split(".")[0]) ===
                  -1
              ) {
                return <></>;
              } else {
                return (
                  <SubMenu
                    key={menuGroup.name}
                    icon={menuGroup.icon}
                    title={
                      menuGroup?.name
                    }
                    className={menuGroup?.className}
                  >
                    {menuGroup.children &&
                      menuGroup.children.map((menuItem: any, index: number) => {
                        if (
                          menuItem?.permission &&
                          myPermissions?.indexOf(menuItem?.permission) === -1 &&
                          myPermissions?.indexOf(
                            menuItem?.permission?.split(".")[0]
                          ) === -1
                        ) {
                          return <></>;
                        } else {
                          return menuItem.key === "name" ? (
                            <li
                              className="crm-size-bar-namecard ant-menu-item ant-menu-item-only-child"
                              key={index}
                            >
                              {menuItem.name}
                            </li>
                          ) : (
                            <Menu.Item
                              onClick={(e) => {
                                // handleClicks(menuItem, e);
                              }}
                              key={menuItem.route}
                            >
                              {menuItem.name}
                            </Menu.Item>
                          );
                        }
                      })}
                  </SubMenu>
                );
              }
            }
          }
        })}
      </Menu>
    </>
  );
};

export default Sidebar;
